import { init } from '@rematch/core';
import loadingPlugin from '@rematch/loading';
import selectPlugin from '@rematch/select';
import reduxThunk from 'redux-thunk';
import config from '@medflex/utils/config';
import chatPlugin from './plugins/chat';
import systemPlugin from './plugins/system';
import messageEventsSubscriber from './plugins/messageEventsSubscriber';

export default function configureStore({ initialState = {}, models } = {}) {
  return init({
    models,
    redux: {
      devtoolOptions: {
        name: 'medflex',
        trace: true,
        actionsBlacklist: ['loading/hide', 'loading/show'],
      },
      initialState: initialState || {},
      reducers: {},
      middlewares: [reduxThunk],
    },
    plugins: [
      systemPlugin(),
      selectPlugin(),
      loadingPlugin(),
      chatPlugin({
        url: config.REALTIME_UPDATES_SERVICE_ENDPOINT,
        protocols: config.REALTIME_UPDATES_PROTOCOL,
      }),
      messageEventsSubscriber(),
    ],
  });
}
